module.exports = __webpack_public_path__ + "26da961b01c841f631a06dfcedbc80fe.jpg";